<template>
    <div class="pt-[20px] pr-[0px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full container mx-auto">
            <div class="lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]">
                <visaNavigation />
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <div class="pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]">
            <h1>Hello World!</h1>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import visaNavigation from '@/components/SubNavigations/TheVisaNavigation.vue'
    import FullButton from '@/components/Buttons/FullButton.vue'

    //breadcrumbs
    const breadcrumbs = [
        {
            title: 'VISA',
            disabled: false,
            href: 'visa',
        },
    ]
</script>
